<script>
  import Login from "./screens/responsible/Login.svelte";
  import Welcome from "./screens/responsible/Welcome.svelte";
  import Survey1 from "./screens/responsible/Survey1.svelte";
  import Survey2 from "./screens/responsible/Survey2.svelte";
  import Survey from "./screens/Survey.svelte";
  import Root from "./screens/Root.svelte";
  import Agradecimiento from "./screens/Agradecimiento.svelte";
  import AgradecimientoResponsible from "./screens/responsible/AgradecimientoResponsible.svelte";
  //import Statistics from "./screens/responsible/Statistics.svelte";
  import SurveyList from "./screens/responsible/SurveyList.svelte";

  import { getToken } from "./js/local";

  import { Router, Route } from "svelte-routing";

  export let url = "";
  const token = getToken();
</script>

<Router {url}>
  <Route path="login">
    <Login />
  </Route>
  <Route path="inicio">
    {#if token !== ""}
      <Welcome />
    {:else}
      <Root />
    {/if}
  </Route>
  <Route path="teoria">
    {#if token !== ""}
      <Survey1 tipoEvaluacion="teoria" />
    {:else}
      <Root />
    {/if}
  </Route>
  <Route path="lab">
    {#if token !== ""}
      <Survey1 tipoEvaluacion="lab" />
    {:else}
      <Root />
    {/if}
  </Route>
  <Route path="evaluador/teoria/:id" let:params>
    {#if token !== ""}
      <Survey2 idInterno={params.id} tipoEvaluacion="teoria" />
    {/if}
  </Route>
  <Route path="evaluador/lab/:id" let:params>
    {#if token !== ""}
      <Survey2 idInterno={params.id} tipoEvaluacion="lab" />
    {/if}
  </Route>
  <Route path="/:id" let:params>
    <Survey idInterno={params.id} />
  </Route>
  <!--<Route path="/:id" let:params>
    {#if token !== ""}
      <Survey2 idInterno={params.id} />
    {:else}
      <Survey idInterno={params.id} />
    {/if}
  </Route>-->
  <Route path="cuestionario-gracias-resp">
    <AgradecimientoResponsible />
  </Route>
  <Route path="cuestionario-gracias">
    <Agradecimiento />
  </Route>
  <Route path="lista-cuestionarios-teoria">
    <SurveyList tipoEvaluacion="teoria" />
  </Route>
  <Route path="lista-cuestionarios-lab">
    <SurveyList tipoEvaluacion="lab" />
  </Route>
  <Route path="/">
    <Root />
  </Route>
</Router>
